import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from '@shared/services/notifications-service/notification.service';
import { Icon } from '@types-custom/models/ui/icon-model';
import { finalize, Subscription } from 'rxjs';

interface NotificationItem {
  id: string;
  state?: boolean;
}

@Component({
  selector: 'sit-notification-menu',
  templateUrl: './notification-menu.component.html',
  styleUrls: ['./notification-menu.component.scss'],
})
export class NotificationMenuComponent implements OnInit, OnDestroy {

  Icon = Icon;
  items: any[] = [];
  loading = false;
  page = 0;
  notificationsAmount = 0;
  // hasMoreData = true;


  private dataSubscription!: Subscription;

  constructor(private dataSource: NotificationService) { }


  ngOnInit(): void {
    this.dataSource.init().subscribe((val) => {
      this.notificationsAmount = val.totalRecords ?? val.totalCount;
    });
    this.init();
  }

  init(): void {
    this.dataSubscription = this.dataSource.data$.subscribe(data => {
      if (data.length > 0) {
        const id = data[0]?.id || data[0]?.base_id;
        (id && this.items.length === 0) && this.dataSource.updateReadNotifications(data[0]?.base_id);
        this.processStatefulData(data);
      } else {
        console.warn('no alerts data')
        // this.hasMoreData = false;
      }
    });
  }

  private processStatefulData(data: NotificationItem[]): void {
    const statefulData = data.map((item, index) => ({
      ...item,
      state: (index + this.items.length) < (this.dataSource.notificationStatus?.getValue().notificationAmount ?? 0),
    }));
    this.items = [...this.items, ...statefulData];
  }

  ngOnDestroy(): void {
    this.dataSubscription?.unsubscribe();
    this.dataSource.resetNotificationStatus();
  }

  onScroll(event: Event): void {
    const target = event.target as HTMLElement;
    const { scrollTop, scrollHeight, clientHeight } = target;
    const scrollThreshold = 55;
    if (
      scrollTop + clientHeight + scrollThreshold >= scrollHeight
      && !this.loading
    ) {
      this.loadMoreItems();
    }
  }

  loadMoreItems(): void {
    if (this.loading) return;

    this.loading = true;
    this.dataSource.fetchPageData({
      page: ++this.page,
      pageSize: 10,
    })
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (data) => {
          if (data) {
            this.notificationsAmount = data.totalRecords ?? data.totalCount ?? 0;
          } else {
            // this.hasMoreData = false;
          }
        },
        error: (error) => {
          console.error('Error fetching page data:', error);
          // this.hasMoreData = false;
        },
      });
  }

}
